import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import {textStyles} from './TextStyles';
import {type TextProps} from './Text.types';

const View = styled('span')(textStyles);

export const Text = React.forwardRef<any, TextProps>((props, ref) => {
  const {color, ...rest} = props;

  return <View data-legacy-ds="Text" {...rest} textColor={color} ref={ref} />;
});

export default Text;
